// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccountData } from './AccountData';
import {
    AccountDataFromJSON,
    AccountDataFromJSONTyped,
    AccountDataToJSON,
} from './AccountData';
import type { EnrichedTransactionTransactionError } from './EnrichedTransactionTransactionError';
import {
    EnrichedTransactionTransactionErrorFromJSON,
    EnrichedTransactionTransactionErrorFromJSONTyped,
    EnrichedTransactionTransactionErrorToJSON,
} from './EnrichedTransactionTransactionError';
import type { Instruction } from './Instruction';
import {
    InstructionFromJSON,
    InstructionFromJSONTyped,
    InstructionToJSON,
} from './Instruction';
import type { NativeTransfer } from './NativeTransfer';
import {
    NativeTransferFromJSON,
    NativeTransferFromJSONTyped,
    NativeTransferToJSON,
} from './NativeTransfer';
import type { Source } from './Source';
import {
    SourceFromJSON,
    SourceFromJSONTyped,
    SourceToJSON,
} from './Source';
import type { TokenTransfer } from './TokenTransfer';
import {
    TokenTransferFromJSON,
    TokenTransferFromJSONTyped,
    TokenTransferToJSON,
} from './TokenTransfer';
import type { TransactionEvent } from './TransactionEvent';
import {
    TransactionEventFromJSON,
    TransactionEventFromJSONTyped,
    TransactionEventToJSON,
} from './TransactionEvent';
import type { TransactionType } from './TransactionType';
import {
    TransactionTypeFromJSON,
    TransactionTypeFromJSONTyped,
    TransactionTypeToJSON,
} from './TransactionType';

/**
 * Contains info about a transaction
 * @export
 * @interface Tx
 */
export interface Tx {
    /**
     * 
     * @type {string}
     * @memberof Tx
     */
    txid: string;
    /**
     * 
     * @type {string}
     * @memberof Tx
     */
    blockHash?: string;
    /**
     * 
     * @type {number}
     * @memberof Tx
     */
    blockHeight: number;
    /**
     * 
     * @type {number}
     * @memberof Tx
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof Tx
     */
    description: string;
    /**
     * 
     * @type {TransactionType}
     * @memberof Tx
     */
    type: TransactionType;
    /**
     * 
     * @type {Source}
     * @memberof Tx
     */
    source: Source;
    /**
     * 
     * @type {number}
     * @memberof Tx
     */
    fee: number;
    /**
     * 
     * @type {string}
     * @memberof Tx
     */
    feePayer: string;
    /**
     * 
     * @type {string}
     * @memberof Tx
     */
    signature: string;
    /**
     * 
     * @type {number}
     * @memberof Tx
     */
    slot: number;
    /**
     * 
     * @type {Array<NativeTransfer>}
     * @memberof Tx
     */
    nativeTransfers: Array<NativeTransfer> | null;
    /**
     * 
     * @type {Array<TokenTransfer>}
     * @memberof Tx
     */
    tokenTransfers: Array<TokenTransfer> | null;
    /**
     * 
     * @type {Array<AccountData>}
     * @memberof Tx
     */
    accountData: Array<AccountData>;
    /**
     * 
     * @type {EnrichedTransactionTransactionError}
     * @memberof Tx
     */
    transactionError: EnrichedTransactionTransactionError | null;
    /**
     * 
     * @type {Array<Instruction>}
     * @memberof Tx
     */
    instructions: Array<Instruction>;
    /**
     * 
     * @type {TransactionEvent}
     * @memberof Tx
     */
    events: TransactionEvent;
}

/**
 * Check if a given object implements the Tx interface.
 */
export function instanceOfTx(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "txid" in value;
    isInstance = isInstance && "blockHeight" in value;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "fee" in value;
    isInstance = isInstance && "feePayer" in value;
    isInstance = isInstance && "signature" in value;
    isInstance = isInstance && "slot" in value;
    isInstance = isInstance && "nativeTransfers" in value;
    isInstance = isInstance && "tokenTransfers" in value;
    isInstance = isInstance && "accountData" in value;
    isInstance = isInstance && "transactionError" in value;
    isInstance = isInstance && "instructions" in value;
    isInstance = isInstance && "events" in value;

    return isInstance;
}

export function TxFromJSON(json: any): Tx {
    return TxFromJSONTyped(json, false);
}

export function TxFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tx {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'txid': json['txid'],
        'blockHash': !exists(json, 'blockHash') ? undefined : json['blockHash'],
        'blockHeight': json['blockHeight'],
        'timestamp': json['timestamp'],
        'description': json['description'],
        'type': TransactionTypeFromJSON(json['type']),
        'source': SourceFromJSON(json['source']),
        'fee': json['fee'],
        'feePayer': json['feePayer'],
        'signature': json['signature'],
        'slot': json['slot'],
        'nativeTransfers': (json['nativeTransfers'] === null ? null : (json['nativeTransfers'] as Array<any>).map(NativeTransferFromJSON)),
        'tokenTransfers': (json['tokenTransfers'] === null ? null : (json['tokenTransfers'] as Array<any>).map(TokenTransferFromJSON)),
        'accountData': ((json['accountData'] as Array<any>).map(AccountDataFromJSON)),
        'transactionError': EnrichedTransactionTransactionErrorFromJSON(json['transactionError']),
        'instructions': ((json['instructions'] as Array<any>).map(InstructionFromJSON)),
        'events': TransactionEventFromJSON(json['events']),
    };
}

export function TxToJSON(value?: Tx | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'txid': value.txid,
        'blockHash': value.blockHash,
        'blockHeight': value.blockHeight,
        'timestamp': value.timestamp,
        'description': value.description,
        'type': TransactionTypeToJSON(value.type),
        'source': SourceToJSON(value.source),
        'fee': value.fee,
        'feePayer': value.feePayer,
        'signature': value.signature,
        'slot': value.slot,
        'nativeTransfers': (value.nativeTransfers === null ? null : (value.nativeTransfers as Array<any>).map(NativeTransferToJSON)),
        'tokenTransfers': (value.tokenTransfers === null ? null : (value.tokenTransfers as Array<any>).map(TokenTransferToJSON)),
        'accountData': ((value.accountData as Array<any>).map(AccountDataToJSON)),
        'transactionError': EnrichedTransactionTransactionErrorToJSON(value.transactionError),
        'instructions': ((value.instructions as Array<any>).map(InstructionToJSON)),
        'events': TransactionEventToJSON(value.events),
    };
}

